// Usage:
// var dev_var = envVar({
// 	static:'myProductionURL',
// 	backend: 'myDevelopmentURL'
// });
var envVar = function(obj) {
	// temporary change to BF repo; need to change this back if you want to use theirs again
//	if (process.env.NODE_ENV === 'development'){
//		return obj['staticPath'];
//	}else if(process.env.NODE_ENV === 'production'){
		return obj['backendPath'];
//	}
}
module.exports = envVar;



// WEBPACK FOOTER //
// ./lib/envVar.js